// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white;
}

.App-title {
  font-size: 1.5em;
}

.App-intro {
  font-size: large;
}

@keyframes App-logo-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.navbar-actions {
  align-items: center;
  display: flex;
  gap: 0.85rem;
}

.navbar-user-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  max-width: 12rem;
}

.navbar-user-avatar {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: rgba(0, 123, 255, 0.12);
  color: #0056b3;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
}

.navbar-user-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3d4550;
  line-height: 1.2;
}

.navbar-toolbar {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
}

.navbar-action {
  align-items: center;
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  width: 2rem;
  margin: 0;
}

.navbar-icon,
.navbar-icon-button .fa,
.network-status-button .fa {
  font-size: 1rem;
  line-height: 1;
}

.navbar-icon-button,
.network-status-button {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  color: #5c6570;
  cursor: pointer;
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  padding: 0;
  width: 2rem;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.navbar-icon-button:hover,
.network-status-button:hover {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.08);
  color: #3d4550;
}

.navbar-icon-button:focus,
.network-status-button:focus {
  outline: none;
}

.navbar-icon-button:focus-visible,
.network-status-button:focus-visible {
  outline: 2px solid #007bff;
  outline-offset: 1px;
}

:root[data-theme="dark"] .navbar-user-avatar {
  background: rgba(0, 123, 255, 0.22);
  color: #9ec9ff;
}

:root[data-theme="dark"] .navbar-user-name {
  color: #e0e5ea;
}

:root[data-theme="dark"] .navbar-icon-button,
:root[data-theme="dark"] .network-status-button {
  color: #b0b8c1;
}

:root[data-theme="dark"] .navbar-icon-button:hover,
:root[data-theme="dark"] .network-status-button:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  color: #e0e5ea;
}

.connectivity-banner {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  font-size: 0.8125rem;
  gap: 0.5rem;
  justify-content: center;
  line-height: 1.25;
  min-height: 30px;
  padding: 0.35rem 1rem;
  text-align: center;
  width: 100%;
}

/* Occupy the existing .navbar margin-bottom gap instead of stacking extra height. */
.navbar + .connectivity-banner {
  margin-top: -30px;
}

.connectivity-banner--offline {
  background: #f8d7da;
  border-bottom: 1px solid #f1b0b7;
  color: #721c24;
}

.connectivity-banner--degraded {
  background: #fff3cd;
  border-bottom: 1px solid #ffe69c;
  color: #664d03;
}

.connectivity-banner--restored {
  background: #d1e7dd;
  border-bottom: 1px solid #a3cfbb;
  color: #0f5132;
}

:root[data-theme="dark"] .connectivity-banner--offline {
  background: #4a1d24;
  border-bottom-color: #6e2b35;
  color: #f5c2c7;
}

:root[data-theme="dark"] .connectivity-banner--degraded {
  background: #3d3420;
  border-bottom-color: #5c4d28;
  color: #ffe69c;
}

:root[data-theme="dark"] .connectivity-banner--restored {
  background: #1e3d32;
  border-bottom-color: #2a5a46;
  color: #a3cfbb;
}

.help-drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.28);
  z-index: 1040;
}

.help-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(420px, 100vw);
  height: 100vh;
  background: #fff;
  border-left: 1px solid #dee2e6;
  box-shadow: -12px 0 30px rgba(15, 23, 42, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}

.help-drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
}

.help-drawer-eyebrow {
  display: block;
  color: #6c757d;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.help-drawer-header h2 {
  margin: 4px 0 0;
  font-size: 22px;
}

.help-drawer-close {
  border: 0;
  background: transparent;
  color: #495057;
  cursor: pointer;
  font-size: 18px;
}

.help-doc-nav {
  display: flex;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #e9ecef;
}

.help-doc-nav-button {
  border: 1px solid #d0d7de;
  border-radius: 6px;
  background: #ffffff;
  color: #374151;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 10px;
}

.help-doc-nav-button:disabled {
  cursor: default;
  opacity: 0.5;
}

.help-drawer-body {
  padding: 20px;
  overflow-y: auto;
  color: #212529;
}

.help-drawer-body h3 {
  margin: 22px 0 8px;
  font-size: 17px;
}

.help-drawer-body h4 {
  margin: 18px 0 8px;
  font-size: 15px;
}

.help-drawer-body p,
.help-drawer-body li {
  font-size: 14px;
  line-height: 1.55;
}

.help-drawer-body ul {
  padding-left: 20px;
}

.help-drawer-body ol.help-ol {
  padding-left: 20px;
}

.help-drawer-body h5 {
  font-size: 14px;
  font-weight: 600;
  margin: 14px 0 6px;
}

.help-hr {
  border: 0;
  border-top: 1px solid #dee2e6;
  margin: 18px 0;
}

.help-table-wrap {
  margin: 14px 0;
  overflow-x: auto;
}

.help-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}

.help-table th,
.help-table td {
  border: 1px solid #dee2e6;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}

.help-table th {
  background: #f1f3f5;
  font-weight: 600;
}

.help-blockquote {
  border-left: 3px solid #ced4da;
  color: #495057;
  margin: 12px 0;
  padding: 2px 0 2px 12px;
}

.help-drawer-body code {
  color: #495057;
}

.help-drawer-body a {
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.help-code-block,
.mermaid {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  color: #212529;
  font-size: 13px;
  margin: 14px 0;
  overflow-x: auto;
  padding: 12px;
}

:root[data-theme="dark"] .help-drawer-backdrop {
  background: rgba(0, 0, 0, 0.52);
}

:root[data-theme="dark"] .help-drawer {
  background: #1f2937;
  border-left-color: #374151;
  color: #e5e7eb;
}

:root[data-theme="dark"] .help-drawer-header {
  border-bottom-color: #374151;
}

:root[data-theme="dark"] .help-doc-nav {
  border-bottom-color: #374151;
}

:root[data-theme="dark"] .help-doc-nav-button {
  background: #111827;
  border-color: #4b5563;
  color: #e5e7eb;
}

:root[data-theme="dark"] .help-drawer-eyebrow {
  color: #9ca3af;
}

:root[data-theme="dark"] .help-drawer-close {
  color: #d1d5db;
}

:root[data-theme="dark"] .help-drawer-body {
  color: #e5e7eb;
}

:root[data-theme="dark"] .help-drawer-body code {
  color: #f9fafb;
}

:root[data-theme="dark"] .help-drawer-body a {
  color: #93c5fd;
}

:root[data-theme="dark"] .help-hr {
  border-top-color: #4b5563;
}

:root[data-theme="dark"] .help-table th,
:root[data-theme="dark"] .help-table td {
  border-color: #4b5563;
}

:root[data-theme="dark"] .help-table th {
  background: #111827;
}

:root[data-theme="dark"] .help-blockquote {
  border-left-color: #6b7280;
  color: #d1d5db;
}

:root[data-theme="dark"] .help-code-block,
:root[data-theme="dark"] .mermaid {
  background: #111827;
  border-color: #374151;
  color: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kFAAkF;AACpF;;AAEA;;EAEE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA,oFAAoF;AACpF;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n\n.App-title {\n  font-size: 1.5em;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n@keyframes App-logo-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.navbar-actions {\n  align-items: center;\n  display: flex;\n  gap: 0.85rem;\n}\n\n.navbar-user-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  max-width: 12rem;\n}\n\n.navbar-user-avatar {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 50%;\n  background: rgba(0, 123, 255, 0.12);\n  color: #0056b3;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 1;\n}\n\n.navbar-user-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #3d4550;\n  line-height: 1.2;\n}\n\n.navbar-toolbar {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.15rem;\n}\n\n.navbar-action {\n  align-items: center;\n  display: inline-flex;\n  height: 2rem;\n  justify-content: center;\n  width: 2rem;\n  margin: 0;\n}\n\n.navbar-icon,\n.navbar-icon-button .fa,\n.network-status-button .fa {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.navbar-icon-button,\n.network-status-button {\n  align-items: center;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  color: #5c6570;\n  cursor: pointer;\n  display: inline-flex;\n  height: 2rem;\n  justify-content: center;\n  padding: 0;\n  width: 2rem;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.navbar-icon-button:hover,\n.network-status-button:hover {\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #3d4550;\n}\n\n.navbar-icon-button:focus,\n.network-status-button:focus {\n  outline: none;\n}\n\n.navbar-icon-button:focus-visible,\n.network-status-button:focus-visible {\n  outline: 2px solid #007bff;\n  outline-offset: 1px;\n}\n\n:root[data-theme=\"dark\"] .navbar-user-avatar {\n  background: rgba(0, 123, 255, 0.22);\n  color: #9ec9ff;\n}\n\n:root[data-theme=\"dark\"] .navbar-user-name {\n  color: #e0e5ea;\n}\n\n:root[data-theme=\"dark\"] .navbar-icon-button,\n:root[data-theme=\"dark\"] .network-status-button {\n  color: #b0b8c1;\n}\n\n:root[data-theme=\"dark\"] .navbar-icon-button:hover,\n:root[data-theme=\"dark\"] .network-status-button:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #e0e5ea;\n}\n\n.connectivity-banner {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  font-size: 0.8125rem;\n  gap: 0.5rem;\n  justify-content: center;\n  line-height: 1.25;\n  min-height: 30px;\n  padding: 0.35rem 1rem;\n  text-align: center;\n  width: 100%;\n}\n\n/* Occupy the existing .navbar margin-bottom gap instead of stacking extra height. */\n.navbar + .connectivity-banner {\n  margin-top: -30px;\n}\n\n.connectivity-banner--offline {\n  background: #f8d7da;\n  border-bottom: 1px solid #f1b0b7;\n  color: #721c24;\n}\n\n.connectivity-banner--degraded {\n  background: #fff3cd;\n  border-bottom: 1px solid #ffe69c;\n  color: #664d03;\n}\n\n.connectivity-banner--restored {\n  background: #d1e7dd;\n  border-bottom: 1px solid #a3cfbb;\n  color: #0f5132;\n}\n\n:root[data-theme=\"dark\"] .connectivity-banner--offline {\n  background: #4a1d24;\n  border-bottom-color: #6e2b35;\n  color: #f5c2c7;\n}\n\n:root[data-theme=\"dark\"] .connectivity-banner--degraded {\n  background: #3d3420;\n  border-bottom-color: #5c4d28;\n  color: #ffe69c;\n}\n\n:root[data-theme=\"dark\"] .connectivity-banner--restored {\n  background: #1e3d32;\n  border-bottom-color: #2a5a46;\n  color: #a3cfbb;\n}\n\n.help-drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.28);\n  z-index: 1040;\n}\n\n.help-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: min(420px, 100vw);\n  height: 100vh;\n  background: #fff;\n  border-left: 1px solid #dee2e6;\n  box-shadow: -12px 0 30px rgba(15, 23, 42, 0.18);\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n}\n\n.help-drawer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.help-drawer-eyebrow {\n  display: block;\n  color: #6c757d;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.help-drawer-header h2 {\n  margin: 4px 0 0;\n  font-size: 22px;\n}\n\n.help-drawer-close {\n  border: 0;\n  background: transparent;\n  color: #495057;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.help-doc-nav {\n  display: flex;\n  gap: 8px;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.help-doc-nav-button {\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #374151;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 10px;\n}\n\n.help-doc-nav-button:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.help-drawer-body {\n  padding: 20px;\n  overflow-y: auto;\n  color: #212529;\n}\n\n.help-drawer-body h3 {\n  margin: 22px 0 8px;\n  font-size: 17px;\n}\n\n.help-drawer-body h4 {\n  margin: 18px 0 8px;\n  font-size: 15px;\n}\n\n.help-drawer-body p,\n.help-drawer-body li {\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.help-drawer-body ul {\n  padding-left: 20px;\n}\n\n.help-drawer-body ol.help-ol {\n  padding-left: 20px;\n}\n\n.help-drawer-body h5 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 14px 0 6px;\n}\n\n.help-hr {\n  border: 0;\n  border-top: 1px solid #dee2e6;\n  margin: 18px 0;\n}\n\n.help-table-wrap {\n  margin: 14px 0;\n  overflow-x: auto;\n}\n\n.help-table {\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n}\n\n.help-table th,\n.help-table td {\n  border: 1px solid #dee2e6;\n  padding: 8px 10px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.help-table th {\n  background: #f1f3f5;\n  font-weight: 600;\n}\n\n.help-blockquote {\n  border-left: 3px solid #ced4da;\n  color: #495057;\n  margin: 12px 0;\n  padding: 2px 0 2px 12px;\n}\n\n.help-drawer-body code {\n  color: #495057;\n}\n\n.help-drawer-body a {\n  color: #2563eb;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.help-code-block,\n.mermaid {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  color: #212529;\n  font-size: 13px;\n  margin: 14px 0;\n  overflow-x: auto;\n  padding: 12px;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-backdrop {\n  background: rgba(0, 0, 0, 0.52);\n}\n\n:root[data-theme=\"dark\"] .help-drawer {\n  background: #1f2937;\n  border-left-color: #374151;\n  color: #e5e7eb;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-header {\n  border-bottom-color: #374151;\n}\n\n:root[data-theme=\"dark\"] .help-doc-nav {\n  border-bottom-color: #374151;\n}\n\n:root[data-theme=\"dark\"] .help-doc-nav-button {\n  background: #111827;\n  border-color: #4b5563;\n  color: #e5e7eb;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-eyebrow {\n  color: #9ca3af;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-close {\n  color: #d1d5db;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-body {\n  color: #e5e7eb;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-body code {\n  color: #f9fafb;\n}\n\n:root[data-theme=\"dark\"] .help-drawer-body a {\n  color: #93c5fd;\n}\n\n:root[data-theme=\"dark\"] .help-hr {\n  border-top-color: #4b5563;\n}\n\n:root[data-theme=\"dark\"] .help-table th,\n:root[data-theme=\"dark\"] .help-table td {\n  border-color: #4b5563;\n}\n\n:root[data-theme=\"dark\"] .help-table th {\n  background: #111827;\n}\n\n:root[data-theme=\"dark\"] .help-blockquote {\n  border-left-color: #6b7280;\n  color: #d1d5db;\n}\n\n:root[data-theme=\"dark\"] .help-code-block,\n:root[data-theme=\"dark\"] .mermaid {\n  background: #111827;\n  border-color: #374151;\n  color: #f9fafb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
